import { EntityCollectionServiceBase, EntityCollectionServiceElementsFactory } from '@ngrx/data';
import { Pickup } from '../models/pickup';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { PickupQuery } from '../models/pickup-query';
import { combineLatest, Observable, of } from 'rxjs';
import { environment } from '../../environments/environment';
import { Injectable } from '@angular/core';
import { map, switchMap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class PickupService extends EntityCollectionServiceBase<Pickup> {

    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory, private http: HttpClient) {
        super('Pickup', serviceElementsFactory);
    }

    get(id: string): Observable<Pickup> {
        return this.entityMap$.pipe(
            map((entities) => entities[id]),
            switchMap((value) => value ? of(value) : this.getByKey(id))
        );
    }

    getMultiple(ids: string[]): Observable<Pickup[]> {
        return combineLatest(ids.map(id => this.get(id)));
    }

    query(query: PickupQuery): Observable<Pickup[]> {
        let params = new HttpParams()
            .set('page', query.pageNumber.toString())
            .set('itemsPerPage', query.itemsPerPage.toString());
        if (query.sortColumn) {
            params = params.set('order[' + query.sortColumn + ']', query.sortDescending ? 'DESC' : 'ASC');
        }
        if (query.reference) {
            params = params.set('reference', query.reference);
        }
        const headers = new HttpHeaders({ Accept: 'application/ld+json' });
        return this.http.get<any>(`${environment.apiUrl}/pickups`, { headers, params });
    }

}
